
module.exports={
  message:{
    high_loan:'您目前最高可贷',
    home:'首页',
    loginIn:'登录',
    loginOut:'登出',
    immit_loan_quickly:'申请借款',
    get_menoy:'收钱',
    info_cjwt:'常见问题',
    info_dkzf:'贷款支付',
    info_lxwm:'联系我们',
    zc_and_sk:'注册并收款',
    loan_mount:'贷款金额',
    loan:'贷款',
    loan_limit:'贷款期限',
    date:'日',
    name:'姓名',
    tel_id:'电话号码',
    code:'密码',
    apply_loan:'申请贷款',
    cx_simple:'程序简单',
    no_dy:'不需要抵押',
    xq_simple:'续签程序简单',
    pay_simple:'付款方式容易',
    day_income:'白天收钱',
    loan_high_money:'贷款金额高',
    why_choose:'为什么选择',
    loan_5_min:'5分钟申请贷款',
    loan_jl:'后续贷款的激励措施',
    simple:'便利性',
    everywhere:'随时随地',
    weiWang:'威望',
    keepScript:'绝对保密您的信息',
    deal_loan:'现代化的财务解决方案',
    run_qg:'在全国范围内运作',
    online_zc:'注册程序完全在线',
    simple_3_step:'3个简单的步骤即可收款',
    input_per_info:'填写个人资料信息',
    contact_U:'将与您联系',
    loan_quickly:'快速贷款',
    simple_2_loan:'轻松贷款，2小时内批准',
    jd_search:'进度查询',
    history_bill:'历史账单',
    repay_now:'立即还款',
    edit_news:'修改信息',
    no_bill:'您没有申请的订单',
    submit_bill_succ:'订单提交成功',
    deal_u_bill:'您的订单正在受理中',
    cl_bill:'订单受理中',
    out_jg:'预计24小时内出审核结果',
    tg_wait_loan:'审核通过，等待放款',
    work_2_loan:'预计2个工作日到账',
    loan_success:'借款成功',
    serch_account:'请查收您的账户',
    orderId:'订单编号',
    loan_amout:'借款金额',
    qs:'期数',
    repay_time:'应还时间',
    apply_status:'申请状态',
    see_detail:'查看详情',
    shz:'审核中',
    sh_refuse:'审核拒绝',
    sh_tg:'审核通过',
    cancle:'已取消',
    yh_manger:'用户管理费',
    apply_quick_loan:'快速申请费',
    interest:'息费',
    Overdue_fj:'逾期罚金',
    apply_date:'申请日期',
    bill_detail:'账单详情',
    com_repay:'确认还款',
    basc_info:'基本信息',
    bank_amount:'银行账户',
    login_code:'登录密码',
    no_edit_pasd:'您暂时不能修改信息',
    add_bank:'添加银行账户',
    default:'默认',
    com_edit_bank:'确定修改此银行账户为默认银行账户？',
    yhy:'已核验',
    hy_w:'未核验',
    hy_error:'核验失败',
    edit_bank:'修改银行账户',
    infos_rz_bank:'您银行账户未认证，请先认证',
    set_success:'设置成功',
    bank_no_set_deauflt:'该账户不支持默认银行账户设置',
    delete_success:'删除成功',
    no_delete_1bank:'绑定的银行账户只剩一个，不支持解绑',
    ipt_psd:'输入新密码',
    ipt_psd_again:'再次输入新密码',
    js_edit_psd:'*注：请谨慎修改您的密码！',
    edit_psd:'修改密码',
    del:'删除',
    ts:'提示',
    reback:'返回',

    psd_login:'密码登录',
    code_login:'验证码登录',
    send_code:'发送验证码',
    IDcardZM:'身份证正面',
    IDcardFM:'身份证反面',
    hold_ID:'手持身份证正面',
    work_photo:'本人工作证照片',
    jx:'继续',
    img_upload_agagin:'图片上传不成功，请重新上传',
    img_upload_success:'图片上传成功',
    upLoad_image_no:'您有图片未上传，请先上传图片',
    Parameter_error:'参数错误',

    gender:'性别',
    fullName:'姓名',
    ID:'身份证',
    age:'出生日期',
    education:'学历',
    marriage:'婚姻',
    income:'收入',
    Career:'职业',
    Companyphone:'公司电话',
    compay:'公司名称',
    adress:'地址',
    city:'城市',
    get_fb_link:'获取FaceBook链接',
    cancel:'取消',
    determine:'确定',

    basc_post_success:'基本信息提交成功',
    jcNEWS:'请检查信息是否填写完整',

    xl_gzyx:'高中以下',
    xl_gz_zz:'高中/中专',
    xl_dz:'大专',
    xl_bk:'本科',

    hy_wh:'未婚',
    hy_yh:'已婚',
    hy_ly:'离异',
    hy_so:'丧偶',

    sr_3jyx:'3000及以下',
    sr_3d6:'3001~6000',
    sr_6d9:'6001~6000',
    sr_9d12:'9001~12000',
    sr_1ys:'12000以上',

    gx_fq:'父亲',
    gx_mq:'母亲',
    gx_po:'配偶',
    gx_zn:'子女',
    gx_qtqs:'其他亲属',
    gx_py:'朋友',
    gx_ts:'同事',
    gx_qt:'其他',

    zy_js:'教师',
    zy_fuy:'服务员',
    zy_sj:'司机',
    zy_wy:'文员',
    zy_kf:'客服',
    zy_xsy:'销售员',
    zy_yj:'邮局',
    zy_ys:'医生',
    zy_jishi:'技师',
    zy_fy:'翻译',
    zy_ls:'律师',

    zy_kj:'会计',
    zy_zj:'咨询员/中介',
    zy_tx:'退休',
    zy_xs:'学生',
    zy_jy:'经营',
    zy_jc:'警察，军人',
    zy_nm:'农民，渔民',
    zy_bw:'保卫',
    zy_yg:'员工',
    zy_jw:'家务',
    zy_jz:'兼职（小时工）',
    zy_qt:'其他',

    contct:'联系人',
    phone:'电话',
    relation:'与您的关系',
    social_info:'社交信息',

    holdName:'持卡人姓名',
    idcar:'身份证号',
    bankCard:'银行账号',
    bankNwes:'银行信息',
    borrowImmediate:'马上借款',
    jiancha:'请检查您的银行账户信息',
    banks_binded:'该银行卡已经关联，请更改为再次关联',
    add_com:'确认添加',
    add_success:'添加成功',

    order_cancel:'订单取消',
    order_shcg:'审核成功',
    order_shjj:'审核拒绝',
    order_wait:'等待放款',
    order_loan_success:'放款成功',
    order_refuse:'放款拒绝',
    order_fkz:'放款中',

    all:'全部',
    dai_wac:'待还款',
    bill_iwc:'已完成',
    bill_repay_status:'还款状态',
    bill_whk:'未还款',
    bill_tchk:'推迟还款',
    bill_whq:'未还清',
    bill_sq_status:'申请状态',
    bill_yhk:'已还款',
    bill_jkqx:'借款期限',
    edit_grxx:'修改个人信息',
    edit_tips:'*注：此信息直接跟您能否借款相关，请如实填写！',
    edit_com:'确认修改',
    edit_success:'修改成功',
    edit_error:'修改失败',
    error_code:'密码错误',
    borrow_lijk:'立即借款',
    borrow_wbdyhk:'未绑定银行账户',
    borrow_bfhtj:'不符合条件',
    borrow_uncomplete:'有未完成的订单',
    borrow_sfbq:'身份证信息不全',
    borrow_nlbg:'年龄不够',
    borrow_rzxxbq:'认证信息不全',
    borrow_system:'系统维护',
    borrow_choose_bank:'请选择正确的银行账户',
    borrow_bfhdktj:'不符合贷款条件',
    pay_total:'应还总额',
    add_bank_tips:'*注：借款资金将系统直接打款到您的银行卡，请务必正确填写银行卡信息，否则有可能导致您的借款无法正常到账!',
    repay_style:'还款方式',
    repay_hklx:'还款类型',
    repay_tips:'*注：提前还款不减免利息！',
    repay_skdw:'收款单位',
    repay_bank_news:'银行信息',
    repay_zh_bank:'银行支行名称',
    repay_zh:'银行账号',
    repay_next_date:'下期还款时间',
    repay_map_new:'地图信息',
    repay_server_money:'服务费',
    repay_code:'交易码',
    repay_bld:'便利店地址',
    repay_hm:'户名',
    repay_zh1:'账号',
    repay_bank:'银行',
    repay_money:'还款金额',
    repay_tq_tips:'*注：提前还款不减免利息!',
    order_no_message:'您没有待还的订单！',

    banksAccount:'银行账户',
    xians:'银行还款',
    xianxia:'商店还款',
    quank:'全款',
    xuq:'续期',
    enterPhone:'请输入手机号',
    ver_code:'验证码',
    message_ipt_code:'请输入验证码',
    ver_code_success:'验证码发送成功',
    ver_code_error:'验证码发送失败',
    login_success:'登录成功',
    login_error:'登录失败',
    index_ts:'轻松贷款，3小时内批准',
    pasenoLOAD:'您暂时不能借款',
    index_rzxx:'认证信息',

    ipt_correct_id:'请输入正确的身份证号码',
    fb_error:'facebook格式不正确',
    sub_new_error:'信息提交失败',
    ipt_has_uIpt:'您有未填写内容',

    trait_1:'来自的贷款',
    trait_1_1:'1-5百万越盾',
    trait_2:'收到钱',
    trait_2_1:'今天的',
    trait_3:'付款方式',
    trait_3_1:'容易的',
    trait_4:'不需要',
    trait_4_1:'抵押',
    trait_5:'续签程序',
    trait_5_1:'简单的',
    step1:'上传照片',
    step2:'填写基本信息',
    yjh_loan:'有机会借钱',
    sel_ipt:'选填',
    sel_ipt1:'(选填)',
    must_ipt:'必填',
    upload_scz:'上传中...',
    upload_scz_error:'上传失败',
    zc:'注册',
    info_lxwm_time:'工作时间：星期一-星期六：08:00-17:00',
    info_lxwm_server:'客服中心:',
    info_dkzf_step1:'前往最近的银行分行或在附近便利店创建交易',
    info_dkzf_step2:'还清贷款并保存银行收据',
    info_cjwt_ybzx:'一般资讯',
    info_cjwt_Q1:'获得贷款需要什么条件？',
    info_cjwt_Q2:'我需要提供什么文件才能获得贷款？',
    info_cjwt_Q3:'您的公司在哪些地区和省提供贷款？',
    info_cjwt_Q4:'我已经填写了申请表。我下一步需要做什么？',
    info_cjwt_a1:'要获得贷款，您必须是18至50岁之间的本国公民，持有效的身份证件。',
    info_cjwt_a2:'您只需要提供您的个人信息即可获得资格。',
    info_cjwt_a3:'我们在所有省份提供服务。',
    info_cjwt_a4:'一旦您的申请获得批准，您将收到短信通知，并且您的贷款将在签署贷款批准后的两个小时内支付。',
    info_cjwt_hddk:'获得贷款',
    info_cjwt_hddk_Q1:'如果我在2小时内仍未收到付款，该怎么办？',
    info_cjwt_hddk_a1:'在2小时之后，如果您尚未收到贷款，请通过热线：',
    info_cjwt_dkzf:'贷款支付',
    info_cjwt_dkzf_Q1:'我可以提前偿还贷款吗？',
    info_cjwt_dkzf_a1:'是的，您可以在到期日之前还清贷款。',
    info_cjwt_dkzf_Q2:'如果我在到期日之后还清贷款会怎样？',
    info_cjwt_dkzf_a2:'您应该在到期日偿还贷款。如果您延迟付款，则将收取滞纳金。',

    deal_photo_cj:'裁剪',
    deal_photo_xz:'图片旋转',
    deal_photo_tjtp:'提交图片',
    deal_photo_cz:'提示',
    deal_photo_text:'请先调整蓝色裁剪框的大小如样图所示，调整完毕后，点击裁剪按钮，然后再点击提交图片按钮',
    deal_photo_sl:'示例',

    ipt_old_psd:'原密码',

    verity_code:'请输入密码',
    verity_iphone:'请输入正确的手机号码',
    loan_data:'借款时间 ',
    rixi_fei:'日息费',
    yuqi_fei:'日息费率',
    cs_mima:'登录密码默认为注册时手机号码后六位',


    btn_info_41:'订单审核中',
    btn_info_44:'审核拒绝',
    btn_info_30:'等待放款',
    btn_info_1:'您有一笔订单',
    btn_info_2:' 您的订单已逾期',
    btn_info_31:'财务拒绝',

    loan_dz:'到账金额',
    loan_dq:'到期时间',
    repay_beizhu:'备注',

    yys_rz:'运营商认证',
    yys_code_success:'验证码发送成功，请输入验证码',
    yys_code_error_click:'验证码发送不成功，请重新点击',
    yys_code_inpt_again:'请再次输入新验证码',
    yys_error_code:'验证码不正确，请重新输入',
    yys_sub:'提交',
    yys_tel:'手机号',
    yys_code:'验证码',
    yys_sub_success:'提交成功',
    Yys_cxfs:'重新认证验证码',
    th_yys_sjh:'手机号',
    th_yys_yzm:'验证码',
    th_yys_qsryzm:'请输入验证码',
    th_yys_sfz:'身份证',
    th_yys_qsrsfz:'请输入身份证',
    th_yys_fhsyy:'返回上一页',
    th_yys_yysmm:'APP登录密码',
    th_yys_qsryysmm:'请填写APP登录密码',
    th_yys_qjxrzsfz:'请继续认证身份证',
    th_yys_hqyzm:'获取验证码',
    th_yys_qx:'权限',
    th_yys_rzcg:'认证成功',

    // 一下是新添加的
    basc_photo:'提交证件',
    yys_tg:'跳过',
    index_shcg:'审核成功',
    index_dws:'待完善',
    index_jdcx:'进度查询',
    index_sqdd:'申请订单',
    index_grzx:'个人中心',
    index_rz_tips:'您有认证未通过，请先完善',
    sch_shz:'审核中',
    sch_dtx:'待提现',
    sch_dhk:'待还款',
    sch_ywc:'已完成',
    sch_ckjd:'查看进度',
    sch_ytg:'已通过',
    sch_tx:'提现',
    sch_txz:'提现中',
    sch_yfk:'已放款',
    sch_hk:'还款',
    sch_yjj:'已拒绝',
    sch_cxjk:'重新借款',
    with_txjw:'可提现金额',
    with_tx_tips:'借款起息日期:以实际放款日为准',
    with_tx_ddxx:'订单信息',
    with_tx_jkr:'借款人',
    with_tx_jkts:'借款天数',
    with_tx_jkje:'借款金额',
    with_tx_dzje:'到账金额',
    with_tx_yhje:'应还金额',
    with_tx_skyh:'收款银行',
    with_tx_skzh:'收款账户',
    with_tx_ljtx:'立即提现',
    view_sc_sqje:'申请金额',
    view_sc_jkmx:'借款明细',
    view_sc_sqsj:'申请时间',
    view_sc_sx:'刷新',
    repay_jlhk:'距离还款日',
    repay_nyyq:'您已逾期',
    repay_hkr:'还款日',
    repay_qjkhk:'请尽快还款',
    repay_yqf:'逾期费',
    repay_yhze:'应还总额',
    borrow_dksq:'贷款申请',
    borrow_nmqzg:'您最高可以申请',
    my_title:'个人中心',
    my_yhzhgl:'银行账户管理',
    my_zxkf:'咨询客服',
    my_logout:'退出登录',
    ser_qxzkf:'请选择需要咨询的客服',
    ser_gfgh:'官方电话',
    ser_nkydj:'您可以直接点击下面的电话号码，将会跳转到您的拨号界面',
    ser_zalo:'官方Zalo',
    ser_addZalo:'您可以添加下面的Zalo号，与我们取得联系',



    /****新版本新添加的待翻译文本******/
    service_timeout:'请求超时,刷新重试',
    for_pass:'忘记密码?试试短信登录',
    use_phone:'为了让您拥有更好的服务体验，请使用手机登录网页',
    choose_banks:'请选择所属银行',
    bind_bank_account:'您还没有绑定用于到账的银行账户',
    home_my:'我的',
    other_gj:'其他工具',
    loan_record:'借款记录',
    sch_sh:'审核',
    yys_tip:'系统将会通过手机运营商,获取您的个人信息',
    choose_yys:'请选择手机运营商',
    rz_intro:'认证说明',
    rz_intro1:'认证手机号码需本人运营商实名认证手机号码',
    rz_intro2:'认证号码必须与注册号码一致',
    rz_intro3:'若遗忘服务密码，可以致运营商服务电话设置',
    start_rz:'开始认证',
    gxntjcg:'恭喜您提交成功',
    fksjts:'当天审核当天放款',
    bank_rz:'银行卡认证',
    bank_rz_tips:'添加银行卡,填写正确的银行账户,银行信息与个人信息要一致,您将迅速获得贷款',
    basc_info_rz:'基本信息认证',
    basc_info_rz_tips:'以下信息仅用于审核贷款额度,我们将依法保护您的信息',
    ipt_u_xm:'请输入姓名',
    ipt_u_bir:'请选择出生日期',
    ipt_u_edu:'请选择教育程度',
    ipt_u_marr:'请选择婚姻状况',
    ipt_u_income:'请选择收入',
    photo_rz:'身份认证',
    photo_rz_tip:'请上传身份照片,仅用于身份核实',
    psyq:'拍摄身份证要求',
    psyq_sfz:'拍摄时确保身份证',
    psyq_sfz_bk:'边框完整,字体清晰,亮度均匀',
    bz:'标准',
    bkqs:'边框缺失',
    zpmh:'照片模糊',
    sgql:'闪光强烈',
    social_rz:'社交认证',
    social_rz_tips:'以下信息仅用于贷款审核额度，我们可能与您提供的亲属联系，并承诺依法对您的信息保密',
    social_rz_tips2:'在审核当中，我们会使用以上信息作为参考，请你填写信息以确保您收到贷款额度',
    repay_yq:'逾期',
    repay_yq1:'请按时还款，以免影响您的信用',
    repay_yq2:'您已逾期,请及时还款',
    male:'男',
    Female:'女',
    tel_psd_rz:'手机或密码不能为空',
    qxz_sty:'请选择',
    yys_reset_wjmm:'忘记密码 ',
    bank_yhmc:'银行名称',
    repay_skzh:'收款账号',
    tian:'天',
    edit_cs_psd:'新客初始原登录密码为111111,为了您的账户安全,注册后,请及时修改登录密码!!!',
    index_jdlc:'简单安全的贷款流程',
    index_syxq:'连接您的所有贷款需求',
    index_ksjklc:'快速借款流程',
    index_pro:'我们的贷款产品',
    index_ty:'在您需要借钱时为您带来良好的体验',
    index_jd:'贷款种类多,网贷灵活,还款操作简单',
    index_tips:'为了给您更好的体验,我们将应用程序设计的非常简单,帮助您轻松验证信息,您的提交申请将被立即审核并快速支付,您可以关注注册批准状态,快速行动,让您随时还贷',
    loan_need:'你需要借多少',
    loan_ed:'贷款额度',
    we_solve:'我们解决什么',
    all_ans:'所有贷款疑问',
    ybxx:'填写信息',
    ybxx_a:'必须是所在国公民，持有效身份证件',
    dk:'申请贷款',
    dk_a:'如果2小时后，您还没有收到贷款，请通过热线联系我们',
    dkzf:'贷款支付',
    dkzf_a:'可以预付,您可以在到期日之前还清贷款',
    why_c:'为什么选择',
    why_lh:'灵活快捷的贷款',
    why_1:'所有贷款的利率都非常低',
    why_2:'99.9%成功获得贷款',
    why_3:'让您灵活还款',
    why_apply:'快速简便的申请流程',
    why_4:'填写您的资料',
    why_5:'申请贷款',
    why_6:'获取贷款',
    jd:'简单',
    tm:'透明',
    aq:'安全',
    get_quck:'快速获得您的贷款',
    rz_succ:'认证完成',
    first_rz:'请先认证基本信息',
    voice_code:'收不到短信?试试语音验证码',
    otp_message:'短信验证码',
    gg_detail:'公告详情',
    mar_tip:'重要提示：请客户不要轻信陌生人发来的还款账号，还款只能还到系统显示的银行账号，不要上当受骗！'
  }
};




// WEBPACK FOOTER //
// ./src/i18/lang/zh.js